import React from "react";

export function UserBubleType2({children}: any) {
  return (
    <div>
      {children}
      <div className="quote-tail">
        <div className="" />
      </div>
    </div>
  )
}


export function BotBubleType2({children}: any) {
  return (
    <div>
      <div className="quote-tail">
        <div className="" />
      </div>
      {children}
    </div>
  )
}
